import { render, staticRenderFns } from "./StaticLinks.vue?vue&type=template&id=f6815f12&scoped=true"
import script from "./StaticLinks.vue?vue&type=script&lang=js"
export * from "./StaticLinks.vue?vue&type=script&lang=js"
import style0 from "./StaticLinks.vue?vue&type=style&index=0&id=f6815f12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6815f12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
